/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentArtifactsControllerGetDownloadUrlQueryResponse, AgentArtifactsControllerGetDownloadUrlPathParams, AgentArtifactsControllerGetDownloadUrlQueryParams } from "../../models/agentArtifactsController/AgentArtifactsControllerGetDownloadUrl";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agentArtifactsControllerGetDownloadUrl } from "../../clients/agent-artifactsService/agentArtifactsControllerGetDownloadUrl";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agentArtifactsControllerGetDownloadUrlQueryKey = (artifactId: AgentArtifactsControllerGetDownloadUrlPathParams["artifactId"], params: AgentArtifactsControllerGetDownloadUrlQueryParams) => [{
  url: '/api/v1/agent-artifacts/:artifactId/download-url',
  params: {
    artifactId: artifactId
  }
}, ...(params ? [params] : [])] as const;
export type AgentArtifactsControllerGetDownloadUrlQueryKey = ReturnType<typeof agentArtifactsControllerGetDownloadUrlQueryKey>;
export function agentArtifactsControllerGetDownloadUrlQueryOptions(artifactId: AgentArtifactsControllerGetDownloadUrlPathParams["artifactId"], params: AgentArtifactsControllerGetDownloadUrlQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agentArtifactsControllerGetDownloadUrlQueryKey(artifactId, params);
  return queryOptions<AgentArtifactsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<Error>, AgentArtifactsControllerGetDownloadUrlQueryResponse, typeof queryKey>({
    enabled: !!(artifactId && params),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agentArtifactsControllerGetDownloadUrl(artifactId, params, config);
    }
  });
}

/**
 * @summary Get a presigned download URL for an agent-generated artifact
 * {@link /api/v1/agent-artifacts/:artifactId/download-url}
 */
export function useAgentArtifactsControllerGetDownloadUrl<TData = AgentArtifactsControllerGetDownloadUrlQueryResponse, TQueryData = AgentArtifactsControllerGetDownloadUrlQueryResponse, TQueryKey extends QueryKey = AgentArtifactsControllerGetDownloadUrlQueryKey>(artifactId: AgentArtifactsControllerGetDownloadUrlPathParams["artifactId"], params: AgentArtifactsControllerGetDownloadUrlQueryParams, options: {
  query?: Partial<QueryObserverOptions<AgentArtifactsControllerGetDownloadUrlQueryResponse, ResponseErrorConfig<Error>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agentArtifactsControllerGetDownloadUrlQueryKey(artifactId, params);
  const query = useQuery({
    ...agentArtifactsControllerGetDownloadUrlQueryOptions(artifactId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}